<template>
    <div>
        <nav class="bg-success navbar navbar-dark navbar-expand-lg pl-lg-5 pl-md-3 pr-lg-5 pr-md-3 fixed-top" :class="{ 'navbar-hidden': !showNavbar }">
            <RouterLink class="navbar-brand" :to="{name: 'Home'}"><img src="@/assets/img/logo/logo-principal.png" height="50px" class="mr-2 rounded-circle shadow-sm"/><span class="font-weight-bold">E.E.S.T. N°2</span></RouterLink>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#Header">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse ml-auto navbar-collapse" ref="header" id="Header">
                <ul class="ml-auto navbar-nav text-center" @click="toggleHeader">
                    <li class="active nav-item hover">
                        <RouterLink :to="{name:'Notices'}" class="nav-link">Noticias</RouterLink>
                    </li>
                    <li class="active nav-item hover">
                        <RouterLink :to="{name:'Books'}" class="nav-link">Biblioteca</RouterLink>
                    </li>

                    <li class="active dropdown nav-item mr-n2">
                        <div class="nav-link">
                            <RouterLink class="text-white text-decoration-none hover" :to="{name: 'School'}">Escuela</RouterLink>
                            <a class="pointer text-white dropdown-toggle dropdown-toggle-split hover" data-toggle="dropdown"></a>
                            <div class="dropdown-menu">
                                <RouterLink class="dropdown-item" :to="{name: 'Technique', params:{id: 'info'}}">Informatica</RouterLink>
                                <RouterLink class="dropdown-item" :to="{name: 'Technique', params:{id: 'mmo'}}">MMO</RouterLink>
                                <RouterLink class="dropdown-item" :to="{name: 'Technique', params:{id: 'auto'}}">Automotores</RouterLink>
                                <RouterLink class="dropdown-item" :to="{name: 'Technique', params:{id: 'electro'}}">Electromecánica</RouterLink>
                                <RouterLink class="dropdown-item" :to="{name: 'Technique', params:{id: 'mecanic'}}">Mecánica</RouterLink>
                            </div>
                        </div>
                    </li>

                    <li class="active nav-item hover">
                        <RouterLink :to="{name:'Contact'}" class="nav-link">Contacto</RouterLink>
                    </li>
                    <template v-if="$store.state.user.user">
                        <li class="active nav-item hover">
                            <RouterLink :to="{name:'Dashboard'}" class="nav-link">Panel</RouterLink>
                        </li>
                        <button class="ml-3 btn btn-danger"  @click="$store.dispatch('user/doLogout')">Salir</button>
                    </template>
                </ul>
            </div>
        </nav>
        <div class="spacer"></div>
    </div>
</template>


<script>
export default {
    name: 'Header',
    data() {
        return {
            showNavbar: true,
            lastScrollPosition: 0
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    methods: {
        onScroll () {
            const currentScrollPosition = window.pageYOffset
            if(Math.abs(currentScrollPosition - this.lastScrollPosition) < 60){
                return
            }
            this.showNavbar = currentScrollPosition < this.lastScrollPosition
            this.lastScrollPosition = currentScrollPosition
        },
        toggleHeader(){
            this.$refs.header.classList.remove('show')
        }
    }
}

</script>